import React from 'react';
import { locales } from '../../../../translations/locales';

const SelectHours = (props) => {
    const { theme, locale, id, editPlanning } = props;

    const now = new Date();
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    return (
        <div className="form-group">
            <label htmlFor={id}>{locales[locale].planning[id]}</label>
            <select
                id={id}
                className={`form-control form-control-sm ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}
            >
                {
                    Array.from({ length: 24 }, (_, i) => {
                        const hour = i.toString().padStart(2, '0');
                        return Array.from({ length: 4 }, (_, j) => {
                            const minutes = (j * 15).toString().padStart(2, '0');
                            if (
                                (editPlanning !== new Date().getDate()) ||
                                (i > currentHour || (i === currentHour && j * 15 >= currentMinutes - (id === 'startPlanningTime' ? 15 : -15)))
                            ) {
                                return (
                                    <option
                                        key={`${hour}:${minutes}`}
                                        value={`${hour}:${minutes}`}
                                    >
                                        {`${hour}:${minutes}`}
                                    </option>
                                );
                            }
                            return null;
                        });
                    }).flat()
                }
                <option
                    key={`23:59`}
                    value={`23:59`}
                >
                    {`23:59`}
                </option>
            </select>
        </div>
    );
};

export default SelectHours;
